import { REQUEST_ALLAPPLICATIONS,
        RECEIVE_ALLAPPLICATIONS_SUCCESS,
        RECEIVE_ALLAPPLICATIONS_ERROR,
        REQUEST_ALLLOANS,
        RECEIVE_ALLLOANS_SUCCESS,
        RECEIVE_ALLLOANS_ERROR,
        REQUEST_UPDATE_ADM_APPLICATION,
        RECEIVE_UPDATE_ADM_APPLICATION_SUCCESS,

        RECEIVE_UPDATE_LOANPARAMETERS,
        REQUEST_UPDATE_APPLICATION_STATUS,
        RECEIVE_UPDATE_APPLICATION_STATUS,
        RECEIVE_UPDATE_APPLICATION_STATUS_ERROR } from '../actions/application';

export function admin(state = {isFetching: true, applications: []}, action) {            
            switch (action.type) {
                case REQUEST_UPDATE_APPLICATION_STATUS: {
                    let  index = state.applications.findIndex(i => i.id === action.data)
                    var newState = {...state,                         
                                    applications: [...state.applications]}                                                                       
                    
                    newState.applications[index] = {...newState.applications[index], isFetching: true};
                    return newState;
                    
                }

                case RECEIVE_UPDATE_LOANPARAMETERS:
                case RECEIVE_UPDATE_APPLICATION_STATUS: {
                    let  index = state.applications.findIndex(i => i.id === action.data.id)
                    var newState = {...state,                         
                                    applications: [...state.applications]}                                                                       
                    
                    newState.applications[index] = {...action.data, isFetching: false};
                    return newState;
                    
                }
                case REQUEST_ALLAPPLICATIONS: {
                    return {...state, isFetching: true}
                }
                case RECEIVE_ALLAPPLICATIONS_SUCCESS: {        
                    return {...state,
                        isFetching: false,
                        applications: action.application
                        }
                }

                case REQUEST_UPDATE_ADM_APPLICATION: {
                    let  index = state.applications.findIndex(i => i.id === action.id)
                    var newState = {...state,                         
                                    applications: [...state.applications]}                                                                       
                    
                    newState.applications[index] = {...newState.applications[index], isFetching: true};
                    return newState;                    
                }

                case RECEIVE_UPDATE_ADM_APPLICATION_SUCCESS: {
                    let  index = state.applications.findIndex(i => i.id === action.application.id)
                    var newState = {...state,                         
                                    applications: [...state.applications]}                                                                                           
                    newState.applications[index] = {...action.application, isFetching: false};
                    return newState;                    
                }
                 
                default: 
                    return state;
            }
}